/*
 * One way to label and caption a photograph, so the Collections viewer
 * (PhotoGallery) and the map's drawer (PointDrawer) say the same thing about
 * the same photo.
 */

/**
 * When and where a photograph was taken, ready to print.
 *
 * Migration 0053 gives a photo four optional tags -- `captured_at`,
 * `capture_lat`/`capture_lng` and `capture_accuracy_m` -- which the photo lists
 * (GET /collections/{id}/photos, GET /map/points/{id}) return to a caller who
 * may see the record's own coordinates, and as nulls otherwise. Field Mode's
 * camera tags every photo; one picked from storage carries what its EXIF
 * says, and a time only when the EXIF names its zone. Any of them may be
 * missing.
 *
 *   when      the moment in the reader's language, or '' (none, or unreadable)
 *   where     "lat, lng" to 5 places (about a metre), or '' -- only when BOTH
 *             are numbers, so 0, 0 is a place and a lone half-fix is not
 *   accuracy  the fix's radius in whole metres, or null
 */
export function captureParts(photo, locale) {
  const p = photo || {};
  const at = p.captured_at ? new Date(p.captured_at) : null;
  const when = at && !Number.isNaN(at.getTime()) ? at.toLocaleString(locale) : '';
  const lat = p.capture_lat;
  const lng = p.capture_lng;
  const where = isNumber(lat) && isNumber(lng) ? `${lat.toFixed(5)}, ${lng.toFixed(5)}` : '';
  const accuracy = isNumber(p.capture_accuracy_m) ? Math.round(p.capture_accuracy_m) : null;
  return { when, where, accuracy };
}

/**
 * A photo's view (its `photo_type`) in the reader's language, from
 * common:photoType. The namespace is named in the key so this works with
 * whichever `t` the caller holds. A type the catalogue lacks reads as itself,
 * underscores as spaces.
 */
export function photoTypeLabel(t, type) {
  if (!type) return '';
  return t(`common:photoType.${type}`, { defaultValue: type.replace(/_/g, ' ') });
}

function isNumber(v) {
  return typeof v === 'number' && Number.isFinite(v);
}
